export const taskStateFilterTypes = {
  ALL_STATES: "all",
  ONGOING: "ongoing",
  RECENT: "recent",
};
